import { Expose } from 'class-transformer';

import { Model } from './model';

export class Pagination extends Model {
  @Expose() total?: number;
  @Expose() perPage?: number;
  @Expose() currentPage?: number;
  
}
